import React from 'react'
import { useIntl } from 'react-intl'
import {hasAcceptedAllTerms, lazyTerms} from '../../../patient/utils/caseRequestUtils'
import {isPaymentPending} from '../../../request/utils'
import {PendingBox} from '../hooks/useNotifyClosedCase'
import { lazyProviderInfo } from '../../../components/WithProvider'

export const PendingInfo = ({caseRequest, hideServiceTerms = false}) => {
  

  const intl = useIntl()
  const providerInfo = lazyProviderInfo.read()
  
  var acceptedTerms = ''
  if(hideServiceTerms){
    acceptedTerms = true
  }else{
    acceptedTerms = hasAcceptedAllTerms(lazyTerms.read(),caseRequest)
  }

  const managePaymentsEnabled = providerInfo?.managePaymentsEnabled
  const hasNoPaidPayment = !caseRequest.payments.find(payment => payment.paid)
  const hasAnyPendingPayment = caseRequest.payments.find(isPaymentPending)

  // Combine the conditions
  // 1. Payment conditions only matter if `managePaymentsEnabled` is true
  // 2. We still show the box if `acceptedTerms` is false
  const shouldShowPendingBox = (
    (managePaymentsEnabled && (hasNoPaidPayment || hasAnyPendingPayment)) 
    || !acceptedTerms
  ) && intl.locale.indexOf("LEGAL") < 0

  if (!shouldShowPendingBox) {
    return null
  }

  return <PendingBox lightYellow>
      <ul>
        {managePaymentsEnabled && (
          <>
            {hasAnyPendingPayment ? (
              <li>There is a payment due for this case.</li>
            ) : hasNoPaidPayment ? (
              <li>No payment has been made.</li>
            ) : null}
          </>
        )}
        {(!acceptedTerms && !hideServiceTerms ) &&
          <li>The service terms have not been signed.  </li>
        }
      </ul>
      Would you still like to proceed?
    </PendingBox>
}